module.exports = __webpack_public_path__ + "img/2019-07-08.c59d2ab0.jpg";